import { ButtonItem, Form, FormRef, GroupItem, RequiredRule, SimpleItem } from 'devextreme-react/form'
import { useRef } from 'react'
import { ArraySourceComposer } from '@/auth/api/connector'
import { personalizzazione, task, user } from '@/model/qsadminapi/QsAdminApiModuleModel'
import { LoadPanel, Popup } from 'devextreme-react'
import { useScreenSize } from '@/themes/media-query'
import { PopupRef } from 'devextreme-react/cjs/popup'
import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import notify from 'devextreme/ui/notify'
import { LoadPanelRef } from 'devextreme-react/cjs/load-panel'
import { ClickEvent } from 'devextreme/ui/button'
import { onInitializedHtmlEditor, onValueChangedHtmlEditor } from '@/routes/utils'

export type SendNotificationSelectorProps = {
  task: task
  customizations: personalizzazione[] | null
  popupRef: React.RefObject<PopupRef>
}

export const SendNotificationSelector = (props: SendNotificationSelectorProps) => {
  const { popupRef, customizations, task } = props
  const formRef = useRef<FormRef>(null)
  const currentScreenSize = useScreenSize()
  const loadPanelRef = useRef<LoadPanelRef>(null)
  const { client } = useQsAdminApiManager()

  const utenti: (user | null | undefined)[] = []
  customizations?.forEach((customization: personalizzazione) => {
    customization.responsabili?.forEach((resp: user) => {
      if (!utenti.some((u) => u?.id === resp.id)) {
        utenti.push(resp)
      }
    })
  })

  const formData: {
    utenti: (user | null | undefined)[]
    note: string
  } = {
    utenti: utenti,
    note: '',
  }

  return (
    <>
      <Popup
        width={currentScreenSize.isLarge || currentScreenSize.isMedium ? 700 : currentScreenSize.isXSmall ? 350 : 700}
        height={currentScreenSize.isSmall ? 320 : currentScreenSize.isXSmall ? 720 : 'auto'}
        hideOnOutsideClick={true}
        title="Invia notifica personalizzazioni"
        showCloseButton={true}
        deferRendering={true}
        ref={popupRef}
        onHiding={() => {
          formRef.current?.instance().updateData('utenti', utenti)
          formRef.current?.instance().updateData('note', '')
        }}
        resizeEnabled={false}
      >
        <div id="send-notification-selector-form-container" className={'dx-card responsive-paddings'}>
          <LoadPanel
            ref={loadPanelRef}
            shadingColor="rgba(0,0,0,0.4)"
            showIndicator={true}
            shading={true}
            showPane={true}
            hideOnOutsideClick={false}
            hideOnParentScroll={false}
            position={{ of: '#send-notification-selector-form-container' }}
          />

          <Form
            id={`send-notification-selector-form}`}
            key={`send-notification-selector-form}`}
            formData={formData}
            ref={formRef}
            validationGroup="sendNotificationSelectorValidation"
          >
            <GroupItem colCount={1}>
              <SimpleItem
                dataField="utenti"
                editorType="dxTagBox"
                label={{ text: 'Utenti' }}
                editorOptions={{
                  dataSource: ArraySourceComposer('id', utenti),
                  displayExpr: 'fullname',
                  placeholder: 'Seleziona utenti...',
                  applyValueMode: 'instantly',
                  showSelectionControls: true,
                  searchEnabled: true,
                }}
              >
                <RequiredRule message="Almeno un utente obbligatorio" />
              </SimpleItem>
            </GroupItem>
            <GroupItem colCount={1}>
              <SimpleItem
                dataField="note"
                label={{ text: 'Note aggiuntive' }}
                editorType="dxHtmlEditor"
                editorOptions={{
                  stylingMode: 'filled',
                  valueType: 'html',
                  mediaResizing: {
                    enabled: true,
                  },
                  imageUpload: {
                    tabs: ['file', 'url'],
                    fileUploadMode: 'base64',
                  },
                  height: 300,
                  onValueChanged: onValueChangedHtmlEditor,
                  onInitialized: onInitializedHtmlEditor,
                }}
              ></SimpleItem>
            </GroupItem>
            <GroupItem cssClass="last-group">
              <GroupItem cssClass="buttons-group" colCount={1}>
                <ButtonItem
                  name="btn-compute"
                  buttonOptions={{
                    icon: 'email',
                    text: 'Invia',
                    width: '150px',
                    onClick: async (e: ClickEvent) => {
                      const validationResult = formRef.current?.instance().validate()
                      if (!validationResult?.isValid) return
                      loadPanelRef.current?.instance().option('visible', true)
                      try {
                        const response = await client.post(
                          'api/task/sendcustomizationsnotification',
                          {
                            users: formData.utenti,
                            notes: formData.note,
                            taskId: task.ded_Dis,
                            customizations: customizations,
                          },
                          {
                            headers: { 'Content-Type': 'application/json' },
                          },
                        )
                        notify(`Notifica inviata con successo.`, 'success', 2000)
                      } catch (error: unknown) {
                        notify(`Errore invio notifica per il task ${task?.ded_Dis}. Dettagli : ${error}`, 'error', 2000)
                      } finally {
                        loadPanelRef.current?.instance().option('visible', false)
                        popupRef.current?.instance().hide()
                        formRef.current?.instance().updateData('utenti', utenti)
                        formRef.current?.instance().updateData('note', '')
                      }
                    },
                  }}
                ></ButtonItem>
              </GroupItem>
            </GroupItem>
          </Form>
        </div>
      </Popup>
    </>
  )
}

export default SendNotificationSelector
